import { FC, HTMLAttributes, PropsWithChildren } from 'react';

import { X } from 'lucide-react';

import { Portal } from '@/components/common/portal';
import { ModalProps } from '@/hooks/use-modal';
import { cn } from '@/lib/utils';

interface ModalLayoutProps extends PropsWithChildren<ModalProps> {
  hideCloseIcon?: boolean;
}

export const ModalLayout: FC<ModalLayoutProps & HTMLAttributes<HTMLDivElement>> = ({
  open,
  onClose,
  children,
  className,
  hideCloseIcon = false,
}) => {
  if (!open) return null;

  return (
    <Portal target="modals-root">
      <div
        onClick={onClose}
        onKeyDown={event => {
          if (event.key === 'Escape') {
            onClose();
          }
        }}
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        className="fixed inset-0 left-0 top-0 z-50 flex h-screen w-full items-center justify-center overscroll-none bg-black/80"
      >
        <div
          onClick={event => event.stopPropagation()}
          onKeyDown={event => event.stopPropagation()}
          role="document"
          className={cn(
            'relative bg-background w-full border border-input rounded-lg p-6',
            className
          )}
        >
          {!hideCloseIcon && (
            <button
              type="button"
              onClick={onClose}
              className="absolute right-4 top-4 h-4 w-4 cursor-pointer border-none bg-transparent p-0 text-muted-foreground transition-opacity hover:opacity-70"
              aria-label="Close modal"
            >
              <X className="h-4 w-4" />
            </button>
          )}

          {children}
        </div>
      </div>
    </Portal>
  );
};
